import { startSegmenterTool } from "./segmenter-tool.js";
import { startTools } from "./start-tools.js";

/**
 * The bundle for the word segmenter.
 *
 * The second bundle that reads characters, so it carries the decoder and the
 * dictionary loading the converter's does. What it leaves out is every
 * transcription system, which is most of what makes `tools-hanzi` the largest
 * of them: this page writes pinyin and nothing else.
 *
 * Loaded by `layouts/tools/single.html` with `type="module"`, which is
 * deferred by definition, so the markup it drives has already been parsed by
 * the time it runs.
 *
 * It exports nothing, which is the point of an entry point.
 */
startTools(document, new Map([["segmenter", startSegmenterTool]]));
